import { useEffect, useState } from 'react';
export function useResizeObserver({ ref, onResize }) {
    const [prevWidth, setPrevWidth] = useState(undefined);
    useEffect(() => {
        if (!ref.current)
            return;
        const observer = new ResizeObserver(() => {
            const currWidth = ref.current?.clientWidth;
            if (currWidth === undefined)
                return;
            if (prevWidth === undefined) {
                setPrevWidth(currWidth);
            }
            else if (prevWidth !== currWidth) {
                setPrevWidth(currWidth);
                onResize(currWidth); // Force re-render
            }
        });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [ref, onResize, prevWidth]);
}
